<template>
  <div :class="wrapperClasses">
    <VueSkeletonLoader
      v-if="loading"
      animation="wave"
      class="min-w-200"
      :color="'#bec3d8'"
      :height="20"
      type="rect"
      :width="20"
    />
    <template v-else>
      <div
        v-if="value != null"
        class="score-status__label"
        :style="{ color: getColorByRiskLevel(value) }"
      >
        {{ getRiskLevelLabel }}
        <span
          v-if="value != null"
          class="score-status__percent"
        > · {{ value }}%</span>
      </div>
    </template>
  </div>
</template>

<script>
// Components
import VueSkeletonLoader from 'skeleton-loader-vue'
// utils
import { getColorByRiskLevel, calculateRiskLevel } from '@/utils/risk-formatter'
import { formatFunds } from '@/utils/report-data-formatter'

export default {
  name: 'ScoreStatus',
  components: {
    VueSkeletonLoader,
  },
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    typeView: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {}
  },
  computed: {
    getRiskLevelLabel() {
      return calculateRiskLevel(this.value)
    },

    wrapperClasses() {
      const classes = ['score-status', `score-status__${this.typeView}`]
      if (this.loading) {
        classes.push('score-status--loading')
      }
      return classes
    },
  },
  methods: {
    getColorByRiskLevel,
    formatFunds,
  },
}
</script>

<style scoped>
.score-status {
  display: flex;
  align-items: center;
  gap: 4px;
  width: fit-content;
}

.score-status__label {
   text-transform: capitalize;
}
</style>
